// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"166":"5a1c581ed0e34f21d83a","172":"735e4b395d3f8f3fc7fb","245":"0d608b6c8490a05826be","388":"c48c4a4eebdb762a40b2","588":"d528350ec02c822ffb93","640":"62f43b2dc4044aab88bd","932":"7d7a15b8e37f86509287"}[chunkId] + ".js";
};